import { Stack } from "@chakra-ui/core";
import { MeetupSpeaker } from "components/Meetup";
import * as React from 'react';
export default {
  Stack,
  MeetupSpeaker,
  React
};